const layoutTypes = {
  default: 'Default',
  square: 'Square with Background Image',
  tile: 'Tile with Gradient Overlay and Background Image',
};

export { layoutTypes as default };
